import { defineMessages } from 'react-intl';

export const messages: {
	deepResearchPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	betaTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deepResearchPill: {
		id: 'rovo.conversation.assistant.agent.deepResearchPill',
		defaultMessage: 'Deep research',
		description:
			'Label text displayed in a pill-shaped badge on agent response messages. Indicates the agent performed deep research to generate the response.',
	},
	betaTag: {
		id: 'rovo.conversation.assistant.agent.deepResearchPillBetaTag',
		defaultMessage: 'Beta',
		description:
			'Label text displayed as a beta indicator badge next to or on the deep research pill. Indicates the deep research feature is in beta/experimental phase.',
	},
});
